import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useAuthProvider } from 'react-admin';
import { NAVIGATION_ROUTE, REDIRECT_TO_URL_QUERY_PARAMS } from '@/utils/CONST';
import CustomBackdrop from '@/components/common/custom-backdrop/custom-backdrop';

const RefreshTokenPage = () => {
    const authProvider = useAuthProvider();
    let { refreshToken }: any = useParams();
    const location = useLocation();
    const navigate = useNavigate();

    const resolveToken = async () => {
        if (refreshToken && authProvider) {
            await authProvider.refreshToken({
                refreshToken,
            });

            const searchParams = new URLSearchParams(location.search);

            const redirectTo = searchParams.has(REDIRECT_TO_URL_QUERY_PARAMS)
                ? searchParams.get(REDIRECT_TO_URL_QUERY_PARAMS)
                : NAVIGATION_ROUTE;

            navigate(`/${redirectTo}`);
        }
    };

    useEffect(() => {
        resolveToken();
    }, []);

    return <CustomBackdrop />;
};

export default RefreshTokenPage;
